<app-modal-title>
    {{title}}
</app-modal-title>
<app-modal-body>
    <div class="ot-message ot-message--is-error">
        <div class="ot-message__banner">
            <p class="title">
                {{message}}
            </p>
        </div>
    </div>
    <div class="table-container">
        <app-datatable [identifier]="'product-resync-table'" [cols]="cols" [rows]="rows" [identifier]="id"></app-datatable>
    </div>
</app-modal-body>
<app-modal-footer>
    <button id="otsc-product-discovery-dialog-close-btn" otsc-button color="primary" i18n-title title="Close" (click)="close()" i18n>
        Close
    </button>
</app-modal-footer>